import { render, staticRenderFns } from "./GuaranteeOnboardingSyntagePage.vue?vue&type=template&id=78511ddb&"
import script from "./GuaranteeOnboardingSyntagePage.vue?vue&type=script&lang=js&"
export * from "./GuaranteeOnboardingSyntagePage.vue?vue&type=script&lang=js&"
import style0 from "./GuaranteeOnboardingSyntagePage.vue?vue&type=style&index=0&id=78511ddb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports